import { cn } from "@lib/cn";

/**
 * The 4px primary bar at the sidebar's right edge that marks the active row.
 * Rendered inside a `tw-relative` row wrapper; `isOpen` is the sidebar's own
 * expanded state, which moves the edge. `className` sets a `top` when the bar
 * marks a row other than the wrapper's own first line — the wrapper must be
 * one that is not `overflow-hidden`, or the bar, which hangs 16px outside it,
 * is clipped away.
 */
export const ActiveNavigationLine = ({
  isOpen,
  className,
}: {
  isOpen: boolean;
  className?: string;
}) => {
  return (
    <span
      className={cn(
        "tw-pointer-events-none tw-absolute -tw-right-4 tw-top-0 tw-z-10 tw-h-8 tw-w-1 tw-rounded-l-lg tw-bg-primary tw-transition-all tw-duration-300 tw-ease-in-out",
        {
          "-tw-right-2": !isOpen,
        },
        className,
      )}
    />
  );
};
